import { render, staticRenderFns } from "./AdminAbsencesView.vue?vue&type=template&id=17513374&scoped=true"
import script from "./AdminAbsencesView.vue?vue&type=script&lang=js"
export * from "./AdminAbsencesView.vue?vue&type=script&lang=js"
import style0 from "./AdminAbsencesView.vue?vue&type=style&index=0&id=17513374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17513374",
  null
  
)

export default component.exports